<template>
  <div class="main_content">
    <p class="card-title">Recruiters</p>
    <div class="card center_horizontal">
      <div class="columns">
        <router-link
          :to="{
            name: 'presence-report',
            query: { month: new Date().getMonth().toString() }
          }"
          class="column admin_link button is-light">
          Presence Report
        </router-link>
        <router-link
          :to="{ name: 'temp-text' }"
          class="column admin_link button is-light">
          Temp Text
        </router-link>
        <a @click="openAlertModal" class="column admin_link button is-light"
          >יצירת משימות ייחודיות</a
        >
      </div>
      <div class="columns">
        <a
          @click="refreshShuffleCache"
          class="column admin_link button is-light"
          >Outsource is Down</a
        >
        <a
          @click="sendFollowupWhatsapp"
          class="column admin_link button is-light">
          Send Whatsapp Followup
        </a>
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'daily-report' }"
          class="column admin_link button is-light">
          Daily Report
        </router-link>
        <router-link
          :to="{ name: 'employers-last-month' }"
          class="column admin_link button is-light">
          מעסיקים - חודש אחרון
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { emit } from '@/custom/classes/my_utils.js'

export default {
  name: 'Recruiters',
  methods: {
    ...mapMutations('modals', ['remove', 'create']),
    openAlertModal () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        init_designator: 'manual_input',
        is_create: true,
        isContentMandatory: false,
        modal_title: 'Create new Item'
      })
    },
    refreshShuffleCache () {
      this.$network_utils.caller
        .request('get', '/outsource_data/reset_cache', 'admin_headers')
        .then(() => {
          emit('show_toast', { text: 'רוענן בהצלחה' })
        })
    },
    sendFollowupWhatsapp () {
      this.$network_utils
        .postEvent({
          event: 'send_followup_whatsapp',
          current_type: 'Applicant',
          max_count: 30,
          current_resource_id: 1
        })
        .then(() => {
          emit('show_toast', { text: 'נשלח בהצלחה' })
        })
    }
  }
}
</script>
<style scoped>
.card {
  padding: 30px;
  padding-bottom: 0;
  width: 1200px;
  margin-top: 20px;
}
.main_content {
  padding: 30px;
}
.admin_link {
  border-color: rgba(0, 0, 0, 0.3) !important;
  display: flex;
  margin-left: 30px;
  margin-right: 30px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
